var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_chevron_right_24px","fill":"#fff","d":"M10,6,8.59,7.41,13.17,12,8.59,16.59,10,18l6-6Z","transform":"translate(-8.59 -6)"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 7.41 12"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
